"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDimenStore = exports.DimenStore = void 0;

var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));

var _mobx = require("mobx");

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _temp;

var DimenStore = (_class = (_temp = /*#__PURE__*/function () {
  (0, _createClass2["default"])(DimenStore, [{
    key: "screenMatch",
    value: function screenMatch(configs) {
      var verySmallScreen = configs.verySmallScreen,
          smallScreen = configs.smallScreen,
          largeScreen = configs.largeScreen;

      if (this.isVerySmallScreen && verySmallScreen != undefined) {
        return verySmallScreen;
      }

      if (this.isSmallScreen && smallScreen != undefined) {
        return smallScreen;
      }

      return largeScreen || configs["default"];
    }
  }, {
    key: "isVeryLargeScreen",
    get: function get() {
      return this.screenInnerWidth >= 1200;
    }
  }, {
    key: "isLargeScreen",
    get: function get() {
      return this.screenInnerWidth >= 900;
    }
  }, {
    key: "isSmallScreen",
    get: function get() {
      return this.screenInnerWidth < 900;
    }
  }, {
    key: "isVerySmallScreen",
    get: function get() {
      return this.screenInnerWidth < 640;
    }
  }, {
    key: "pageGuideX",
    get: function get() {
      return this.isSmallScreen ? "3%" : "15%";
    }
  }, {
    key: "pageGuideXForPageWithTable",
    get: function get() {
      return this.isSmallScreen ? "3%" : "5%";
    }
  }, {
    key: "pageGuideBottom",
    get: function get() {
      return "90px";
    }
  }], [{
    key: "instance",
    value: function instance() {
      var _ref = window,
          dimenStore = _ref.dimenStore;

      if (dimenStore == null) {
        dimenStore = new DimenStore();
        window.dimenStore = dimenStore;
      }

      return dimenStore;
    }
  }]);

  function DimenStore() {
    var _this = this;

    (0, _classCallCheck2["default"])(this, DimenStore);
    (0, _initializerDefineProperty2["default"])(this, "screenInnerWidth", _descriptor, this);
    (0, _initializerDefineProperty2["default"])(this, "screenInnerHeight", _descriptor2, this);
    (0, _initializerDefineProperty2["default"])(this, "pageScrolled", _descriptor3, this);
    (0, _initializerDefineProperty2["default"])(this, "pageYOffset", _descriptor4, this);
    window.addEventListener("resize", function () {
      (0, _mobx.runInAction)(function () {
        _this.screenInnerWidth = window.innerWidth;
        _this.screenInnerHeight = window.innerHeight;
      });
    });
    window.addEventListener("scroll", function () {
      (0, _mobx.runInAction)(function () {
        _this.pageYOffset = window.pageYOffset;
        _this.pageScrolled = true;
      });
    });
  }

  return DimenStore;
}(), _temp), (_descriptor = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "screenInnerWidth", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return window.innerWidth;
  }
}), _descriptor2 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "screenInnerHeight", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return window.innerHeight;
  }
}), _descriptor3 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "pageScrolled", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor4 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "pageYOffset", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return window.pageYOffset;
  }
}), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "isVeryLargeScreen", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isVeryLargeScreen"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "isLargeScreen", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isLargeScreen"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "isSmallScreen", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isSmallScreen"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "isVerySmallScreen", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isVerySmallScreen"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "pageGuideX", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "pageGuideX"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "pageGuideXForPageWithTable", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "pageGuideXForPageWithTable"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "pageGuideBottom", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "pageGuideBottom"), _class.prototype)), _class);
exports.DimenStore = DimenStore;

var useDimenStore = function useDimenStore() {
  return new DimenStore();
};

exports.useDimenStore = useDimenStore;